module.exports = __webpack_public_path__ + "media/images/landkit/photos/photo-27-2f47d6cdc59f1b755cef7bdf787cbfa1.jpg";